<img *ngIf="routeparam?.detailsEntered" src="{{trackierSource}}" />
<section class="IL_ilite_congrats_banner congrats-banner">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="congrats-content">
                    <img class="IL_ilite_pay_done_icon" src="assets/img/check-circle.png">
                    <h1 class="IL_ilite_register_thnx">Thank You for Registering!</h1>
                    <h6>Pay  <span><i class="fas fa-rupee-sign"></i></span>  <strong class="strong-rs"> 249</strong> to block your seat</h6>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="user-sec">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="user-content">
                    <div class="user-head">
                        <h1>10th October, 2 PM to 3:30 PM</h1>
                        <a  ><button (click)="razorPayWindowPrestep()" type="button" class="congrtas-startlearnbtn">PAY NOW</button></a>
                        <p>Limited seats available</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="query-contact">
                    <h4>For more query,  we are available here</h4>
                    <ul class="congrats-contact">
                        <li><i class="fa fa-phone" aria-hidden="true"></i><a href="#">9019846666</a></li>
                        <li><i class="fa fa-envelope-o" aria-hidden="true"></i><a href="#">info@infinitylearn.com</a></li>
                        <li><img src="assets/img/globe.png"> <a href="#">9019846666</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>